<template>
  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Attendance</span></h4>
    </div>

    <div class="container-fluid px-0 mt-4">
      <div class="mt-4 rounded">

        <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
          <b-tab lazy title-link-class="p-0">
            <template #title>
              Monthly Attendance
            </template>

            <div>
              <roster-employees-attendance :roster="roster"></roster-employees-attendance>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0">
            <template #title>
              Daily Attendance
            </template>

            <div>
              <roster-calendar-daily :flag="true" :roster="roster"></roster-calendar-daily>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0" v-if="roster">
            <template #title>
              Attendance Calendar
            </template>

            <div>
              <roster-calendar-monthly></roster-calendar-monthly>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0" v-if="roster">
            <template #title>
              Roster Tools
            </template>

            <roster-employee-data></roster-employee-data>
          </b-tab>

          <b-tab lazy title-link-class="p-0" v-if="$acl['roster/attendance/adjustment'] == 2 && regularization == 1">
            <template #title>
              Attendance Adjustment
            </template>
            <roster-attendance-adjustment :roster="roster"></roster-attendance-adjustment>
          </b-tab>

          <b-tab lazy title-link-class="p-0" v-if="$acl['roster/attendance/adjustment'] == 2 && regularization == 1">
            <template #title>
              Attendance Mobility Requests
            </template>
            <roster-attendance-mobility-requests :roster="roster"></roster-attendance-mobility-requests>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>


<script>
export default {

  props:['roster', 'regularization'],
  data() {
    return {
    };
  },

};
</script>